import React from 'react';
import './Tarot.css';

const Tarot = ({ sign }) => {
  return (
    <div className="container_group">
      <div className="card-tirada">
        <div className="">
          <p className="size-title-tirada">Tirada Tarot</p> {/* Título del signo */}
          <p className="custom-date-tirada">Da clic a la carta {sign}</p> {/* Fecha */}
          <p className="custom-short-tirada">
            Y consulta tu tirada
          </p> {/* Descripción corta */}
        </div>
        <div className="imagen-tirada">
            <img alt='nada' src='/images/tirada.png'/>
        </div>
      </div>
    </div>
  );
};


export default Tarot;
